var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 48.041,
    viewBox: "0 0 40 48.041",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_366",
    "data-name": "Groupe 366",
    transform: "translate(-455.929 -48.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_563",
    "data-name": "Trac\\xE9 563",
    d: "M489.929,96.691h-28a6.006,6.006,0,0,1-6-6v-36a6.007,6.007,0,0,1,6-6h.012c9.426.059,14.743,0,17.6-.028,3.567-.038,3.631-.038,4.284.617.4.4,5.13,6.353,6.045,7.509,6.063,7.662,6.063,7.753,6.063,8.623V90.691A6.007,6.007,0,0,1,489.929,96.691Zm-28-44a2,2,0,0,0-2,2v36a2,2,0,0,0,2,2h28a2,2,0,0,0,2-2V65.985c-1.46-2.042-8.436-10.829-10.493-13.338-.461,0-1.114.008-1.856.016C476.715,52.693,471.383,52.75,461.924,52.691Z",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1352",
    "data-name": "Rectangle 1352",
    d: "M472.224,49.691h0a2.5,2.5,0,0,1,2.5,2.5v24a2.5,2.5,0,0,1-2.5,2.5h0a2.5,2.5,0,0,1-2.5-2.5v-24A2.5,2.5,0,0,1,472.224,49.691Z",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1353",
    "data-name": "Rectangle 1353",
    d: "M471.724,72.191h0a2.5,2.5,0,0,1,2.5-2.5h5a2.5,2.5,0,0,1,2.5,2.5h0a2.5,2.5,0,0,1-2.5,2.5h-5A2.5,2.5,0,0,1,471.724,72.191Z",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1354",
    "data-name": "Rectangle 1354",
    d: "M462.724,67.191h0a2.5,2.5,0,0,1,2.5-2.5h5a2.5,2.5,0,0,1,2.5,2.5h0a2.5,2.5,0,0,1-2.5,2.5h-5A2.5,2.5,0,0,1,462.724,67.191Z",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1355",
    "data-name": "Rectangle 1355",
    d: "M471.724,62.191h0a2.5,2.5,0,0,1,2.5-2.5h5a2.5,2.5,0,0,1,2.5,2.5h0a2.5,2.5,0,0,1-2.5,2.5h-5A2.5,2.5,0,0,1,471.724,62.191Z",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1356",
    "data-name": "Rectangle 1356",
    d: "M462.724,58.191h0a2.5,2.5,0,0,1,2.5-2.5h5a2.5,2.5,0,0,1,2.5,2.5h0a2.5,2.5,0,0,1-2.5,2.5h-5A2.5,2.5,0,0,1,462.724,58.191Z",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_564",
    "data-name": "Trac\\xE9 564",
    d: "M473.429,90.528h-2a4.756,4.756,0,0,1-4.75-4.75V80.191a4.756,4.756,0,0,1,4.75-4.75h2a4.756,4.756,0,0,1,4.75,4.75v5.587A4.756,4.756,0,0,1,473.429,90.528Zm-2-11.587a1.251,1.251,0,0,0-1.25,1.25v5.587a1.25,1.25,0,0,0,1.25,1.25h2a1.251,1.251,0,0,0,1.25-1.25V80.191a1.252,1.252,0,0,0-1.25-1.25Z",
    fill: "#5d5d5d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.ebf62f0c7f43f7371b5fe178a194f928.svg";
export { ForwardRef as ReactComponent };